import React from "react";
import { InputFile } from "../../../../common/index";

const CV = ({ selectCvFile, cvName }) => (
  <div className="row my-1">
    <div className="mx-auto bg-grey p-hf rounded" style={{ width: 264 }}>
      <div className="col-12 col-sm-4 px-0 float-left ">
        <InputFile
          onChangeHandler={selectCvFile}
          classes="btn btn-block btn-info px-0 mb-0 fontSize-12"
          idName="cvFile"
        />
      </div>
      <div className="text-nowrap col-8 col-sm-8 mt-hf pl-1 pr-0">
        <span className="address_cvName">{cvName}</span>
      </div>
    </div>
  </div>
);

export default CV;
